import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import ProductIconText from '../../../Optimum/OptimumProductCards/ProductIconText';
import Pills from '../../../../Core/Pills';
import BannerBlock from '../../../Banners/BannerBlock';
import SimpleImageBanner from '../../../Banners/SimpleImageBanner';

import {
  Block,
  Content,
  ImageWrapper,
  LegalCopy,
  Header,
  Heading,
  StyledCtas,
  Footer,
  BodyCopy,
} from './styles';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <LegalCopy>{children}</LegalCopy>,
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <BodyCopy>{children}</BodyCopy>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data } = node;
      if (
        data.target &&
        data.target.__typename === 'ContentfulTitleOrImageWithIconLists'
      ) {
        return <ProductIconText data={data.target} className="spotlight" />;
      }
      if (data.target && data.target.component === 'banner-block') {
        return <BannerBlock data={data.target} className="spotlight" />;
      }
      if (data.target && data.target.component === 'simple-image-banner') {
        return <SimpleImageBanner data={data.target} className="spotlight" />;
      }
      return null;
    },
  },
};

const SpotlightBlock = ({ className = '', data }) => {
  if (!data) return null;

  const {
    heading,
    imageDam,
    bodyCopy,
    bottomCopy,
    ctas,
    pillText,
    pillTextColor,
    pillBackgroundColor,
    pillIcon,
    textAlignment,
  } = data;

  const headline = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading $textAlignment={textAlignment}>{children}</Heading>
      ),
    },
  };

  return (
    <Block className={className}>
      {imageDam && (
        <ImageWrapper $image={imageDam.asset.localImage.publicURL} />
      )}
      <Header className="heading-container">
        {pillText && (
          <Pills
            backgroundColor={pillBackgroundColor}
            textColor={pillTextColor}
            pillIcon={pillIcon}
          >
            {pillText}
          </Pills>
        )}
        {heading && <RichText document={heading} options={headline} />}
      </Header>
      <Content>
        {bodyCopy && <RichText document={bodyCopy} options={body} />}
      </Content>
      {ctas && (
        <Footer>
          {bottomCopy && <RichText document={bottomCopy} options={options} />}
          <StyledCtas ctas={ctas} direction="row" alignment="left" />
        </Footer>
      )}
    </Block>
  );
};

SpotlightBlock.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

export default SpotlightBlock;
